// Custom app entry. CRITICAL ORDER: register the Android home-screen widget's
// headless task BEFORE the app entry is evaluated.
//
// The widget's background task runs in a bare *headless* JS context that loads THIS
// same bundle top-to-bottom. `expo-router/entry` eagerly mounts the whole app
// (require.context 'sync' over src/app) and runs every screen's load-time native
// init — the Supabase AppState listener, AdMob, Firebase, NativeWind, etc. Any of
// those throwing in the headless context (no Activity / partial native bridge) used
// to abort this file *before* the widget task was registered → `RNWidgetBackgroundTask`
// never existed → the OS rendered a blank tile (so even the immediate empty render
// never showed). Fix: register the task FIRST, then `require` (NOT `import`, which
// would hoist back above us) the app entry, guarded so a headless-context throw can't
// strand the already-registered task. In the normal app context the require never
// throws.
import { Platform } from 'react-native';

if (Platform.OS === 'android') {
  const { registerWidgetTaskHandler } = require('react-native-android-widget');
  const { widgetTaskHandler } = require('./src/widgets/taskHandler');
  registerWidgetTaskHandler(widgetTaskHandler);
  // Define the live-score background task in every JS context, including the
  // headless one that wakes for a data-only push while the app is closed.
  require('./src/lib/notifications/live');
}

try {
  require('expo-router/entry');
} catch (err) {
  // Only the headless widget context should ever reach here (the full app module
  // graph hitting a native init that needs an Activity). Swallow it there so the
  // already-registered widget task still runs; rethrow everywhere else so a real
  // app-entry failure stays visible.
  if (Platform.OS !== 'android') throw err;
  console.warn('[index] expo-router/entry load failed (headless widget context?):', err);
}
